import { Route, Switch, Redirect } from 'react-router-dom';

import TutorialsPage from 'features/tutorials/pages/TutorialsPage';

import { rootPaths } from 'routes/paths';
import { tutorialsPaths } from 'features/tutorials/routes/paths';
import { Title } from 'shared';
import { useTranslation } from 'hooks/useTranslation';

export const TutorialsRouter = () => {
  const { t } = useTranslation('app');

  return (
    <>
      <Title title={t('tutorials')} />
      <Switch>
        <Route exact path={tutorialsPaths.static.root} component={TutorialsPage} />
        <Route>
          <Redirect to={rootPaths.static.notFound} />
        </Route>
      </Switch>
    </>
  );
};
